import { Folder } from 'iconsax-react';

const icons = {
    folder: Folder,
};

const projectsItem = {
    id: 'projects-group',
    // title: 'Projects',
    type: 'group',
    children: [
        {
            id: 'all-projects',
            title: 'All Projects',
            type: 'item',
            url: '/projects/all-projects',
            icon: icons.folder,
            breadcrumbs: true
        }
    ]
};

export default projectsItem;
